<template>
    <div class="header-section">
        <p class="form-subtitle" style="cursor: pointer;" @click="$router.push('/list-tournament')">
            <i class="fa fa-arrow-left"></i> Back
        </p>
        <h1 class="form-title">Edit Program</h1>
        <p class="form-subtitle"></p>
    </div>
    <form @submit.prevent="submitForm">
    <div class="">
        <div class="row col-md-12">
             <!-- Category -->
            <div class="col-md-4">
            <label for="category">Name</label>
            <input 
                class="form-control"
                type="text" 
                id="title"
                placeholder="Enter tournament name"
                required 
                v-model="name"
            />
            </div>

            <!-- Title -->
            <div class="col-md-4">
            <label for="title">Club </label>
            <select id="category" class="form-control" required v-model="club">
                    <option disabled value="">-- Select club --</option>
                    <option v-for="(data, index) in dataListClub" :key="index" :value="data.id">{{ data.club_name }}</option>
             </select>
            </div>

            <!-- Location -->
            <div class="col-md-4">
            <label for="description">Location</label>
            <input 
                class="form-control"
                type="text" 
                id="title"
                placeholder="Enter location"
                required 
                v-model="location"
            />
        
            </div>
        </div>

        <div class="row col-md-12 mt-2">
             <!-- Category -->
            <div class="col-md-4">
            <label for="category">Start Date</label>
            <input 
                class="form-control"
                type="date" 
                id="title"
                placeholder="Enter tournament name"
                required 
                v-model="start_date"
            />
            </div>

            <!-- Title -->
            <div class="col-md-4">
            <label for="title">End Date </label>
            <input 
                class="form-control"
                type="date" 
                id="title"
                placeholder="Enter club name"
                required 
                v-model="end_date"
            />
            </div>

            <!-- Location -->
            <div class="col-md-4">
            <label for="description">Reg. Deadline</label>
            <input 
                class="form-control"
                type="date" 
                id="title"
                placeholder="Enter location"
                required 
                v-model="registration_deadline"
            />
        
            </div>
        </div>

        <div class="row col-md-12 mt-2">
             <!-- Category -->
            <div class="col-md-4">
            <label for="category">Type</label>
                <select id="category" class="form-control" required v-model="type">
                    <option disabled value="">-- Select tournament type --</option>
                    <option v-for="(data, index) in dataListType" :key="index" :value="data.id">{{ data.type }}</option>
                </select>
            </div>

            <!-- Title -->
            <div class="col-md-4">
                <label for="category">Category</label>
                <select id="category" class="form-control" required v-model="category">
                    <option disabled value="">-- Select Category --</option>
                    <option v-for="(data, index) in dataList" :key="index" :value="data.id">{{ data.category }}</option>
                </select>
            </div>

            <!-- Location -->
            <div class="col-md-4">
            <label for="description">Age</label>
            <input 
                class="form-control"
                type="text" 
                id="title"
                placeholder="Enter age limits"
                required 
                v-model="age_limits"
            />
            </div>
        </div>

        <div class="row col-md-12 mt-2">

            <!-- Slot -->
            <div class="col-md-4">
            <label for="description">Slot</label>
            <input 
                class="form-control"
                type="text" 
                id="title"
                placeholder="Enter number of slots"
                required 
                v-model="slot"
            />
            </div>

            <div class="col-md-4">
            <label for="description">Fee</label>
            <input 
                class="form-control"
                type="text" 
                id="title"
                placeholder="Enter entry fees"
                required 
                v-model="entry_fee"
            />
            </div>
        </div>
    </div>

    <div class="buttons mt-4">
        <button type="submit">Submit</button>
    </div>
    </form>

</template>
<script setup>
/* eslint-disable */ 
import { CircleCheck, Image } from "lucide-vue-next";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import router from "@/router";
import { useRoute } from 'vue-router'
import Editor from '@tinymce/tinymce-vue'

// In setup function
const route = useRoute()

const fileInput = ref(null);
const files = ref([]);
const dataList = ref([]);
const dataListType = ref([]);
const dataListClub = ref([]);
const dataListEdit = ref([]);
const created_by = ref(localStorage.getItem('userid'));

const name = ref('')
const club = ref('')
const location = ref('')
const start_date = ref('')
const end_date = ref('')
const registration_deadline = ref('')
const type = ref('')
const category = ref('')
const age_limits = ref('')
const slot = ref('')
const entry_fee = ref('')
let dataId = ref('');

onMounted( async () => {
    dataId.value = route.params.id
    await listRecords()
    await listTypes()
    await listRecordEdit()
    await listClubs()
});

function triggerFileInput() {
    fileInput.value.click();
}

function handleFileChange(event) {
    const selectedFile = event.target.files[0]; // only one banner at a time

    if (selectedFile) {
        const fileObj = reactive({
            name: selectedFile.name,
            file: selectedFile,
            progress: 0,
            preview: selectedFile.type.startsWith("image/")
                ? URL.createObjectURL(selectedFile)
                : null
        });
        files.value = [fileObj]; // replace with new file
    }

    event.target.value = "";
}
const listRecordEdit = async () => {
  try {
    const response = await axios.get(`/tournament_edit.php?id=${dataId.value}`, { });
    if (response.data.status){
       
        dataListEdit.value = response.data.data;
        name.value = dataListEdit.value.name
        club.value = dataListEdit.value.club
        location.value = dataListEdit.value.location
        start_date.value = dataListEdit.value.start_date
        end_date.value = dataListEdit.value.end_date
        registration_deadline.value = dataListEdit.value.registration_deadline
        type.value = dataListEdit.value.type
        category.value = dataListEdit.value.category
        age_limits.value = dataListEdit.value.age_limits
        slot.value = dataListEdit.value.slot
        entry_fee.value = dataListEdit.value.entry_fee

    }
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
const listClubs = async () => {
  try {
    const response = await axios.get('/club_lists.php', { });
    if (response.data.status) dataListClub.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
const listRecords = async () => {
  try {
    const response = await axios.get('/tournament_category.php', { });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
const listTypes = async () => {
  try {
    const response = await axios.get('/tournament_type.php', { });
    if (response.data.status) dataListType.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
async function submitForm() {

    const formData = new FormData();
    formData.append("id", dataId.value);
    formData.append("name", name.value);
    formData.append("club", club.value);
    formData.append("location", location.value);
    formData.append("start_date", start_date.value);
    formData.append("end_date", end_date.value);
    formData.append("registration_deadline", registration_deadline.value);
    formData.append("type", type.value);
    formData.append("category", category.value);
    formData.append("age_limits", age_limits.value);
    formData.append("slot", slot.value);
    formData.append("entry_fee", entry_fee.value);
    formData.append("updated_by", created_by.value);

    try {
        const response = await axios.post(
            "/tournament_update.php", // change to your backend URL
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
              
            }
        );

            alert(response.data.message);

             name.value = ""
             club.value = ""
             location.value = ""
             start_date.value = ""
             end_date.value = ""
             registration_deadline.value = ""
             type.value = ""
             category.value = ""
             age_limits.value = ""
             slot.value = ""
             entry_fee.value = ""

            router.push("/list-tournament");
            
 
    } catch (error) {
        console.error(error);
        alert(error.response ? error.response.data.message : error.message);
    }
}
</script>
<style lang="scss" scoped>

.setup-form {
    max-width: 95%;
    margin: 0 auto;
    padding: 24px;
    display: flex;
    justify-content: between;
    gap: 24px;
    align-items: start;
}

.header-section {
    max-width: 90%;
    margin: 0 auto 20px auto;
}

.header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
    width: 50%;
    box-shadow: #6C757D33 0px 1px 3px 0px, #6C757D1A 0px 1px 2px 0px;
    border: 1px solid #EBF1FF;
    border-radius: 20px;
    padding: 40px;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: start;
    width: 100%;
    margin-top: 20px;
}

.form-group label {
    font-size: 16px;
    color: #495057;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.form-group textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #94A3B8;
    border-radius: 8px;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
    resize: vertical;
}

.form-group input:focus {
    border-color: #4C6EF5;
}

.buttons {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    width: 90%;
    margin: 0 auto 40px auto;
}

.buttons button {
    flex: 1;
    padding: 12px 16px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s, color 0.3s;
}

.buttons button:first-child {
    background-color: #FF1F25;
    color: #fff;
}

.buttons button:first-child:hover {
    background-color: #c92f34;
    color: #fff;
}

.buttons button:last-child {
    background-color: #ED4E24;
    color: #fff;
}

.buttons button:last-child:hover {
    background-color: #d35533;
    color: #fff;
}

.form-title {
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
    color: #020617;
}

.form-subtitle {
    text-align: left;
    font-size: 16px;
    color: #020617;
    margin-bottom: 20px;
}

.upload-section {
    margin-top: 20px;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 12px;
    text-align: center;
    background: #fafafa;
    max-width: 90%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
}

.upload-section input[type="file"] {
    display: none;
}

.file-list-section {
    max-width: 90%;
    padding: 10px;
    margin: 15px auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.file-item {
    background-color: #FAFAFA;
    border: 1px solid #ccc;
    width: 50%;
    margin-top: 15px;
    text-align: left;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.file-name {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    padding: 0%;
    margin: 0%;
    width: 20%;
}

.progress-container {
    height: 4px;
    width: 80%;
    background: #eee;
    border-radius: 10px;
    position: relative;
}

.progress-bar {
    height: 100%;
    background: red;
    border-radius: 10px;
    transition: width 0.3s;
}

.progress-container span {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.file-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

@media (max-width: 768px) {
    .setup-form {
        flex-direction: column;
        padding: 0px;
        max-width: 100%;
        margin: 0%;
    }

    .header {
        width: 100%;
        padding: 20px;
    }

    .buttons {
        flex-direction: column;
        width: 100%;
        margin: 0 auto 20px auto;
    }

    .upload-section {
        margin-top: 20px;
        padding: 20px;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }

    .file-list-section {
        max-width: 100%;
        padding: 8px;
        margin: 12px auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .file-item {
        background-color: #FAFAFA;
        border: 1px solid #ccc;
        width: 100%;
        margin-top: 15px;
        text-align: left;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
    }

}
</style>